import { render, staticRenderFns } from "./LoadingTopicComment.vue?vue&type=template&id=f2e13428&"
import script from "./LoadingTopicComment.vue?vue&type=script&lang=ts&"
export * from "./LoadingTopicComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports